export const verifyOtpMutation = (builder) => ({
  verifyOtp: builder.mutation({
    query: (credentials) => ({
      url: '/verify_user_otp',
      method: 'POST',
      body: credentials,
    }),
  }),
});